import * as React from 'react';
import { SVGProps } from 'react';

const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.26 18.672a1 1 0 0 1 .068-1.413l5.8-5.259-5.8-5.26a1 1 0 0 1 1.344-1.48l6.617 6a1 1 0 0 1 0 1.48l-6.617 6a1 1 0 0 1-1.413-.068Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgArrowRight;
